import { state } from './state';
import mutations from './mutations';

const modal = {
  state,
  mutations,
};

export default modal;
